import Http from '../http'

export default {

  index(filter) {
    return Http.get(`/company_financials`, {params: {...filter}})
  },


  create(company_financial){
    return Http.post(`/company_financials`, {company_financial: {
      ...company_financial,
    }})
  },

  update(company_financial){
    return Http.put(`/company_financials/${company_financial.id}`, {
      company_financial: {
        ...company_financial,
      },
    });
  },

  show(id) {
    return Http.get(`/company_financials/${id}`);
  },

  delete(id){
    return Http.delete(`/company_financials/${id}`)
  }

}